module.exports = "<h1>{{title}}</h1>\n<app-carousel></app-carousel>\n<button class=\"btn btn-info\" routerLink=\"products/all\" id=\"shop-now\">Shop Now!</button>\n<hr width=\"80%\">\n<app-welcome-extras-bar></app-welcome-extras-bar>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/welcome/welcome.component.html
// module id = 412
// module chunks = 1